'use strict';

module.exports.decodeValue = decodeValue;
module.exports.encodeValue = encodeValue;
module.exports.decode = decode;
module.exports.encode = encode;

var tokens_map = {
    '\\\\': '\\',
    '\\:': ';',
    '\\s': ' ',
    '\\n': '\n',
    '\\r': '\r'
};

var token_lookup = /\\\\|\\:|\\s|\\n|\\r/gi;

function decodeValue(value) {
    return value.replace(token_lookup, function (m) {
        return tokens_map[m] || '';
    });
}

var vals_map = {
    '\\': '\\\\',
    ';': '\\:',
    ' ': '\\s',
    '\n': '\\n',
    '\r': '\\r'
};

var val_lookup = /\\|;| |\n|\r/gi;

function encodeValue(value) {
    return value.replace(val_lookup, function (m) {
        return vals_map[m] || '';
    });
}

function decode(tag_str) {
    var tags = Object.create(null);

    tag_str.split(';').forEach(function (tag) {
        var parts = tag.split('=');
        var key = parts[0].toLowerCase();
        var value = parts[1];

        if (!key) {
            return;
        }

        // if no value is given for this tag, just set it to true
        if (typeof value === 'string') {
            value = decodeValue(value);
        } else {
            value = true;
        }
        tags[key] = value;
    });

    return tags;
}

function encode(tags) {
    var parts = Object.keys(tags).map(function (key) {
        var val = tags[key];

        if (typeof val === 'boolean') {
            return key;
        }

        return key + '=' + encodeValue(val.toString());
    });

    return parts.join(';');
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/irc-framework/build/messagetags.js
// module id = Rt5D
// module chunks = 0